import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { ButtonEventsService } from '../../services/button-events.service';
import { CmxLayoutService } from '../../services/cmx-layout.service';
import { LegalEntityService } from '../../services/legal-entity.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'cmx-sidebar',
  templateUrl: './cmx-sidebar.component.html',
  styleUrls: ['./cmx-sidebar.component.scss'],
})
export class CmxSidebarComponent implements OnInit, OnDestroy {
  public isMobile: boolean;
  public isCollapsed: boolean;
  public isLegalEntityListOpen: boolean;
  public isRtl: boolean;
  public isModalOpen: boolean;
  public variant: string;
  public userCountry: string;
  public footerLabel: string;
  public version: number;
  public sidebarHeight = '100%';

  private subscriptions: Subscription[] = [];

  @Input()
  public entityName: string = null;
  @Input()
  public entityId: string = null;
  @Input()
  public employeeVariant = false;

  @Output()
  isCollapsedEvent: EventEmitter<boolean> = new EventEmitter();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.sidebarHeight = '100%';
  }

  constructor(
    public layout: CmxLayoutService,
    public legalEntity: LegalEntityService,
    public menu: MenuService,
    public buttons: ButtonEventsService,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.layout.isMobile.subscribe((value) => (this.isMobile = value)),
      this.layout.direction.subscribe((value) => (value === 'rtl' ? (this.isRtl = true) : (this.isRtl = false))),
      this.layout.isCollapsed.subscribe((value) => (this.isCollapsed = value)),
      this.layout.isLegalEntityListOpen.subscribe((value) => (this.isLegalEntityListOpen = value)),
      this.legalEntity.isModalOpen.subscribe((value) => (this.isModalOpen = value)),
      this.layout.variantHeader.subscribe((value) => (this.variant = value)),
      this.layout.userCountry.subscribe((value) => (this.userCountry = value)),
      this.layout.footerLabel.subscribe((value) => (this.footerLabel = value)),
      this.layout.version.subscribe((value) => (this.version = value)),
    );
  }

  toggleCollapse() {
    this.layout.isCollapsed.next(!this.isCollapsed);
  }

  mobileLangClick() {
    this.layout.isMobileLangSelectorOpen.next(true);
    this.layout.isMobileEntitySelectorOpen.next(false);
    this.layout.isMobileMenuOpen.next(false);
  }

  mobileUserClick() {
    this.buttons.user.emit();
    this.layout.isMobileMenuOpen.next(false);
  }

  mobileLinkClick(id: number) {
    this.layout.mobileLinkClick.emit(id);
    this.layout.isMobileMenuOpen.next(false);
  }

  mobileLogutClick() {
    this.buttons.logout.emit();
    this.layout.isMobileMenuOpen.next(false);
  }

  mobileAppMenuClick() {
    this.layout.isMobileAppSelectorOpen.next(true);
    this.layout.isMobileLangSelectorOpen.next(false);
    this.layout.isMobileEntitySelectorOpen.next(false);
    this.layout.isMobileMenuOpen.next(false);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  privacyPolicyClick() {
    window.alert('Triggered by a javascript function');
  }

  outlerLink() {
    window.alert('Hi');
  }

  sideNavMenuRendered(isRendered) {
    this.layout.sideBarMenuRendered.next(true);
  }

  isSidenavOpen(value) {
    console.log(value.detail);
    this.isCollapsedEvent.emit(value.detail);
  }
}
